var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLaunchBriefMd({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#launchBrief-md_svg__clip0_277_8820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.536 6.665a1.584 1.584 0 00-2.238 0l-1.586 1.588v-4.18c0-.422-.165-.82-.463-1.118l-1.492-1.492A1.572 1.572 0 0012.638 1H3.583c-.872 0-1.582.71-1.582 1.582v14.836c0 .872.71 1.582 1.582 1.582H14.13c.872 0 1.582-.71 1.582-1.582v-4.689l3.824-3.827a1.581 1.581 0 000-2.237zm-6.988-4.61c.1 0 .291-.018.463.154l1.492 1.492c.167.167.154.35.154.463h-2.11v-2.11zm2.11 15.363c0 .29-.237.527-.528.527H3.583a.528.528 0 01-.527-.527V2.582c0-.29.236-.527.527-.527h7.91V4.69c0 .292.236.528.527.528h2.637v4.09l-1.556 1.556-.745.746a.528.528 0 00-.127.206l-.746 2.237a.527.527 0 00.667.667l2.237-.745a.526.526 0 00.206-.128l.064-.064v3.634zm-1.183-5.434l.745.745-.285.285-1.118.373.373-1.118.285-.285zm1.491 0l-.746-.746L16.755 8.7l.746.745-2.535 2.538zm3.824-3.828l-.544.544-.745-.745.543-.545a.528.528 0 01.746.746z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.02 6.273H4.639a.527.527 0 000 1.055h7.383a.527.527 0 000-1.055zM9.911 8.383H4.638a.527.527 0 000 1.055H9.91a.527.527 0 100-1.055zM9.911 10.492H4.638a.527.527 0 100 1.055H9.91a.527.527 0 100-1.055zM9.911 12.602H4.638a.527.527 0 100 1.054H9.91a.527.527 0 100-1.054zM12.02 15.836H8.857a.527.527 0 000 1.055h3.165a.527.527 0 000-1.055z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "launchBrief-md_svg__clip0_277_8820"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(2 1)",
    d: "M0 0h18v18H0z"
  })))));
}

export default SvgLaunchBriefMd;